import { render, staticRenderFns } from "./DevelopmentDocumentRequest.vue?vue&type=template&id=4d2d4e4c&"
import script from "./DevelopmentDocumentRequest.ts?vue&type=script&lang=ts&"
export * from "./DevelopmentDocumentRequest.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports